import React from "react";

import { BetBuilderPickActionsTypeEnum } from "@data-types/analytics-tracker/QuickPlayInteractionTypeEnum";
import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import { BetBuilderPicksStore } from "@state/quick-play-store/BetBuilderPicksStore";
import { analyticsTracker } from "@utils/analytics";
import classNames from "classnames";
import { observer } from "mobx-react";

export default observer(function BetBuilderPicksQuotaButton(props: {
	BBPick: BetBuilderPick;
	isInPopup?: boolean;
	store: BetBuilderPicksStore;
}) {
	const { BBPick, isInPopup = false } = props;

	const addOrRemovePick = async (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		e.stopPropagation();

		if (props.store.isAddingOrRemovingPick) {
			return;
		}

		analyticsTracker.trackQuickPlayInteraction(
			BetBuilderPickActionsTypeEnum.PickUse
		);

		if (!props.store.checkIsSelectedMultiOfferOnSlip(BBPick)) {
			analyticsTracker.trackUseTicketEvent("bb-picks");
		}
		await props.store.addOrRemoveBetBuilderPickOnSlip(BBPick);

		if (isInPopup) {
			props.store.deactivatePopup();
		}
	};

	const isQuoteActive = props.store.checkIsSelectedMultiOfferOnSlip(BBPick);

	const quotaClasses = classNames({
		"card--bbp__quota quote quote--button quote--button--bbp btn btn--block":
			!isInPopup,
		"popup--most__btn quote--button btn btn--med btn--block": isInPopup,
		"btn--icon inc": BBPick.indicator > 0,
		"btn--icon desc": BBPick.indicator < 0,
		"is-active": isQuoteActive,
	});

	return (
		<button
			type="button"
			className={quotaClasses}
			onClick={addOrRemovePick}
			title={BBPick.bbMaxCoefficient.toFixed(2)}
		>
			<strong className="quote--button__odd u-type--center">
				{BBPick.bbMaxCoefficient.toFixed(2)}
			</strong>
		</button>
	);
});
